export default __webpack_public_path__ + "static/media/nerveLogoWhite.8ebe4e9a.png";